// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1oK2f","itemTitle":"ClientEmergencyInfo_itemTitle__2uKG6","itemText":"ClientEmergencyInfo_itemText__24hb1"};